import React from 'react';
import Icon from '../AppIcon';

const MobileMenuToggle = ({ isOpen, onToggle }) => {
  return (
    <button
      onClick={onToggle}
      className="
        flex items-center justify-center w-10 h-10 rounded-md
        text-foreground hover:bg-muted hover:text-primary
        transition-government focus:outline-none focus:ring-2 
        focus:ring-accent focus:ring-offset-2 min-h-44
      "
      aria-label={isOpen ? 'ปิดเมนู' : 'เปิดเมนู'}
      aria-expanded={isOpen}
    >
      <Icon 
        name={isOpen ? 'X' : 'Menu'} 
        size={24} 
        className="transition-government"
      />
    </button>
  );
};

export default MobileMenuToggle;